export default __webpack_public_path__ + "static/media/hhn.e027e924.png";